import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WINDOW } from '@ng-toolkit/universal';
import * as $ from 'jquery';
declare function ire(string,{}): any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FAQComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    @Inject(WINDOW) private window: Window,
    ) { }

    ngOnInit() {
      this.titleService.setTitle('트링카 지원 센터 - FAQs');
      this.metaTagService.updateTag({ name: 'description', content: "트링카에 관한 FAQs를 통해 공통적으로 궁금증에 대한 질문의 답변을 확인하실 수 있습니다." });
      this.metaTagService.updateTag({ property: 'og:title', content: '트링카 지원 센터 - FAQs' });
      this.metaTagService.updateTag({ property: 'og:description', content: '트링카에 관한 FAQs를 통해 공통적으로 궁금증에 대한 질문의 답변을 확인하실 수 있습니다.' });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/faqs' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/faqs' });
      
    }
    gotoTop() {
      if (isPlatformBrowser(this.platformId)) {
        $.getScript('../../../assets/js/wisepop.js', function () { });
        $.getScript('../../../assets/js/faq_schema_final.js', function () { });
        this.window.scroll({
          top: 450,
          left: 0,
          behavior: 'smooth'
        });
      }
    }

    generateGuid() {
      var result, i, j;
      result = '';
      for(j=0; j<32; j++) {
        if( j == 8 || j == 12 || j == 16 || j == 20)
          result = result + '-';
        i = Math.floor(Math.random()*16).toString(16).toUpperCase();
        result = result + i;
      }
      return result;
    }
}
